import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ProffeoThemeService } from '@app/shared/ui/theme/proffeo-theme.service';
import { ProffeoTokenOverrideService } from '@app/shared/ui/theme/proffeo-token-override.service';

@Component({
  selector: 'proffeo-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent {
  private readonly themeService = inject(ProffeoThemeService);
  private readonly tokenOverrideService = inject(ProffeoTokenOverrideService);

  public constructor() {
    this.themeService.applyDefaultTheme();
    this.tokenOverrideService.restorePersistedOverrides();
  }
}
